<div class="tr-timepicker" #pickerParentRef>
  <div class="dropdown">
    <div>
      <input
        type="text"
        id="{{ elementId }}"
        class="form-control"
        [ngClass]="{'invisible': isTimepickerInvisible, 'is-invalid': isInvalid}"
        autocomplete="off"
        [disabled]="disabled"
        [(ngModel)]="timepickerModel"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="validateInput($event)"
        (blur)="onblur($event)"
        [attr.placeholder]="placeholder"
        [readonly]="!inputCanBeFocused"
        inputTime
      >
    </div>
  </div>
</div>

<ion-modal
  class="popover-modal time-suggestions"
  [keyboardClose]="false"
  [isOpen]="showSuggestion && suggestedTime"
  [showBackdrop]="false"
  [animated]="false"
  (didDismiss)="clickOutside()"
  (willPresent)="calculateActualContentPosition()"
  (click)="clickOutside()"
>
  <ng-template>
    <div
      class="popover-modal-content border-border background-background"
      [style.left.px]="pickerLeft"
      [style.top.px]="pickerTop"
      [style.width.px]="pickerWidth"
      (click)="noBubble($event)"
    >
      <p (click)="selectSuggested('AM')" class="hover-item order-border m-0 pl-3 py-1">
        {{suggestedTime}} AM
      </p>
      <p (click)="selectSuggested('PM')" class="hover-item border-border m-0 pl-3 py-1">
        {{suggestedTime}} PM
      </p>
    </div>
  </ng-template>
</ion-modal>
